const NON_TEXT_CONTENT_REGEX = /<(img|iframe|video|hr|table)\b/i;

export function hasHtmlContent(html) {
  if (!html) return false;
  if (NON_TEXT_CONTENT_REGEX.test(html)) return true;

  const text = html
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/gi, ' ')
    .trim();

  return text.length > 0;
}

export function preserveEmptyParagraphs(html) {
  if (!html) return html;
  return html.replace(/<p(\s[^>]*)?>((?:\s|&nbsp;|\u200b)*)<\/p>/gi, '<p$1><br></p>');
}

export function joinSplitSentences(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const toLine = p => {
    const line = doc.createElement('span');
    line.className = 'wysiwyg-line';
    line.append(...p.childNodes);
    return line;
  };
  doc.querySelectorAll('p').forEach(p => {
    const prev = p.previousElementSibling;
    if (prev?.tagName !== 'P' || prev.style.cssText !== p.style.cssText) return;
    if (!/[^.!?:;\u2026]$/.test(prev.textContent.trim()) || !/^\p{Ll}/u.test(p.textContent.trim())) return;
    // El widget parte los bloques de mas de 2700 caracteres por cualquier nodo: por encima de 2500 no se unen
    if (prev.textContent.length + p.textContent.length > 2500) return;
    if (prev.firstChild?.className !== 'wysiwyg-line') prev.append(toLine(prev));
    prev.append(toLine(p));
    p.remove();
  });
  return doc.body.innerHTML;
}
